exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.align-right[data-v-33597d8c] {\n  text-align: right;\n}\n.align-center[data-v-33597d8c] {\n  text-align: center;\n}\n.nowrap[data-v-33597d8c] {\n  white-space: nowrap;\n}\ntable tr th[data-v-33597d8c] {\n  background: none;\n}\n", ""]);

// exports
